import { createAction } from 'redux-actions';
export const SET_ORDER_PRICE = 'SET_ORDER_PRICE';
export const setOrderPrice = createAction(SET_ORDER_PRICE);
